import { Box, Radio, Typography, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { IconWithCircle } from "nemuru-components";
import React from "react";
import { useTranslation } from "../../../utils/hooks/useTranslation";

export const DocumentTypeSelectableRow = ({
  label,
  selected = false,
  onSelect,
}) => {
  const { palette, spacing, breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const { getTextIdTranslation } = useTranslation();

  const ariaLabel =
    typeof label === "string"
      ? label
      : label?.props?.tId
      ? getTextIdTranslation(`${label.props.tId}_ARIA_LABEL`)
      : undefined;

  return (
    <Box
      my={1}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      onClick={onSelect}
      style={{ height: spacing(3), cursor: "pointer" }}
    >
      <Typography
        color={selected ? "textPrimary" : "textSecondary"}
        variant={isScreenXs ? "subtitle2" : "subtitle1"}
        component="div"
      >
        <strong>{label}</strong>
      </Typography>
      {selected ? (
        <IconWithCircle
          backgroundColor={palette.primary.main}
          height={spacing(3)}
          width={spacing(3)}
          className="material-icons"
          style={{
            fontSize: spacing(2),
            color: palette.primary.contrastText,
          }}
        >
          check
        </IconWithCircle>
      ) : (
        <Radio
          inputProps={{
            "aria-label": ariaLabel,
          }}
          style={{
            padding: 0,
            margin: "0.25rem",
            background: palette.grey[50],
            height: "16px",
            width: "16px",
          }}
          size="medium"
        />
      )}
    </Box>
  );
};
